import React from "react";
import "./online.scss";
import { useSelector } from "react-redux";
import ShowContainer from "../../../mui/ShowContainer";
import { useTranslation } from "react-i18next";

export default function Online() {
  const userOnline = useSelector((state) => state.site.serverInfo?.online);
  const { t } = useTranslation();

  return (
    <ShowContainer condition={userOnline}>
      <div className="online__indicator">
        <span className="online__indicator__text">{t("Online")}</span>
        <div className="online__indicator__circle" />
        <span className="online__indicator__count">{userOnline}</span>
      </div>
    </ShowContainer>
  );
}
